import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Lock } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function formatDetail(detail) {
  if (detail == null) return 'Something went wrong.';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === 'string' ? e.msg : JSON.stringify(e))).join(' ');
  if (detail && typeof detail.msg === 'string') return detail.msg;
  return String(detail);
}

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    document.title = 'Admin · Absolute Marine Equipment';
    const token = localStorage.getItem('admin_token');
    if (token) navigate('/admin', { replace: true });
  }, [navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email, password });
      localStorage.setItem('admin_token', data.token);
      localStorage.setItem('admin_email', data.email);
      navigate('/admin', { replace: true });
    } catch (err) {
      setError(formatDetail(err.response?.data?.detail) || err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-black text-white flex items-center justify-center px-5" data-testid="admin-login-page">
      <div className="w-full max-w-md panel rounded-xl p-8 border border-white/10">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-10 h-10 rounded-md bg-cyan-500/10 border border-cyan-400/30 flex items-center justify-center text-cyan-300">
            <Lock className="w-5 h-5" />
          </div>
          <div>
            <div className="text-[11px] uppercase tracking-[0.24em] text-zinc-500">Absolute Marine Equipment</div>
            <h1 className="font-display text-white text-xl font-semibold">Admin Sign-in</h1>
          </div>
        </div>

        <form onSubmit={submit} className="space-y-5" data-testid="admin-login-form">
          <label className="block">
            <div className="text-[11px] uppercase tracking-[0.22em] text-zinc-500 mb-2">Email</div>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-black/60 border border-white/10 focus:border-cyan-400/60 outline-none rounded-md px-4 py-3 text-white"
              placeholder="admin@absolutebarges.com"
              data-testid="admin-login-email"
            />
          </label>
          <label className="block">
            <div className="text-[11px] uppercase tracking-[0.22em] text-zinc-500 mb-2">Password</div>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-black/60 border border-white/10 focus:border-cyan-400/60 outline-none rounded-md px-4 py-3 text-white"
              placeholder="••••••••••"
              data-testid="admin-login-password"
            />
          </label>

          {error && (
            <div className="text-red-400 text-sm" data-testid="admin-login-error">{error}</div>
          )}

          <button
            type="submit"
            disabled={submitting}
            className="btn-teal w-full px-5 py-3 rounded-md text-sm uppercase tracking-[0.18em] disabled:opacity-60"
            data-testid="admin-login-submit"
          >
            {submitting ? 'Signing in…' : 'Sign in'}
          </button>
        </form>
      </div>
    </div>
  );
}
